<template lang="pug">
  .component-reject-driver-request-buttons
    .dropdown-buttons
      CashInPreauthReveal(:preauth="item")
      ActionButton(:action="refresh", confirm) Refresh
      ActionButton(:action="cancelPreauth", confirm) Cancel
</template>

<script>
import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
import MaggieHelper from "../../../../maggieHelper";
import ActionButton from "../ActionButton.vue";
import CashInPreauthReveal from "../../../../pages/backoffice/CashInPreauthReveal.vue";
import {EventBus} from "../../../../eventBus";

export default {
  name: "PreauthButtons",
  components: {CashInPreauthReveal, ActionButton},
  methods: {
    cancelPreauth() {
      return KeplerBackofficeSdk.preauth.select(this.item.id).cancel(() => {
        MaggieHelper.notification('', 'preauth canceled')
        EventBus.$emit('reload-list')
      })
    },
    refresh() {
      return KeplerBackofficeSdk.preauth.select(this.item.id).refresh(() => {
        MaggieHelper.notification('', 'preauth refreshed')
        EventBus.$emit('reload-list')
      })
    }
  },
  props: ["item"]
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// PreauthButtons.vue?c8a6450c